import RecessAPI from '@services/RecessAPI'
import Ably from 'ably'

class RecessRT

  @ably: null 

  @init = ->
    @ably = new Ably.Realtime authUrl: "#{RecessAPI.endpointPath()}/ably?member_token=#{RecessAPI.memberToken}", xyz: 123

    onConnected = =>
      clientId = @ably.auth.tokenDetails.clientId || 'anonymous';
      memberToken = RecessAPI.memberToken

      console.log "#{clientId is memberToken }: ClientID [#{clientId}] == MemberToken [#{memberToken}]"
      capability = @ably.auth.tokenDetails.capability;
      console.log @ably.auth.tokenDetails
      console.log(
        'You are now connected to Ably \n' +
        'memberId: ' + clientId + ' \n' +
        'Capabilities: ' + capability
      );
      console.log "Token: #{memberToken}"

      channel = @ably.channels.get('api-stream:recess:quickstart')
      channel.subscribe 'greeting', (message) ->
        console.log "Received a greeting message in realtime: #{message.data}"

      memberChannel = @ably.channels.get("api-stream:recess:member:*")
      memberChannel.subscribe 'data', (message) ->
        console.log "Received a message in realtime: #{message}"

    @ably.connection.once('connected', onConnected)

export default RecessRT